import StyledSelect from "./../../../../../product/all-products/components/custom/StyledSelect";
import { BootstrapInput } from "./../bootStrapInput/index";
import "./index.css";

const CountryCodeInput = ({
  countryOptions,
  customerMobileNumber,
  setCustomerMobileNumber,
  handleKeyPress,
  selectedCountry,
  handleCountryChange,
}) => {
  const isIndia = selectedCountry?.value === "+91";
  const maxDigits = isIndia ? 10 : 15;
  const minDigits = isIndia ? 10 : 7;

  const handleNumberInput = (e) => {
    const number = e.target.value;
    if (number.length > maxDigits) {
      return;
    }
    setCustomerMobileNumber(number);
  };
  return (
    <div className="country-code-input">
      <StyledSelect
        className="country-select"
        value={selectedCountry}
        onChange={handleCountryChange}
        options={countryOptions}
      />
      <BootstrapInput
        placeholder="Enter Mobile Number"
        id="bootstrap-input"
        autoFocus
        type="number"
        minLength={minDigits}
        maxLength={maxDigits}
        className="phone-input"
        value={customerMobileNumber}
        onChange={handleNumberInput}
        onKeyDown={handleKeyPress}
      />
    </div>
  );
};

export default CountryCodeInput;
